<template>
    <!-- Science direction -->
    
    <div v-if="this.$store.getters.Loaded && this.$store.getters.GetBlock.scdir" class="uk-container uk-container-center uk-text-center uk-margin-top uk-position-z-index-negative">
        <div v-if="this.$store.getters.GetBlock.notifications"></div>
        <h1 class="uk-heading" id="science_direction">{{this.$store.getters.GetText.scdir.title[this.$store.getters.Lang]}}</h1>
        <h3 class="uk-heading">{{this.$store.getters.GetText.scdir.subtitle[this.$store.getters.Lang]}}</h3>
        <div class="uk-child-width-expand@s uk-text-center uk-position-z-index-negative" uk-grid>
            <div>
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                    <img class="tm-image-pull uk-position-z-index-negative" src="../assets/img/sc_dir/1-round.png" width="200" height="200" alt="1">
                    <h4>{{this.$store.getters.GetText.scdir.block_one[this.$store.getters.Lang]}}</h4>
                </div>
            </div>
            <div>
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                    <img class="tm-image-pull " src="../assets/img/sc_dir/2-round.png" width="200" height="200" alt="2">
                    <h4>{{this.$store.getters.GetText.scdir.block_two[this.$store.getters.Lang]}}</h4>
                </div>
            </div>
            <div>
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                    <img class="tm-image-pull" src="../assets/img/sc_dir/3-round.png" width="200" height="200" alt="3">
                    <h4>{{this.$store.getters.GetText.scdir.block_three[this.$store.getters.Lang]}}</h4>
                </div>
            </div>
            <br>
        </div>
        <div class="uk-child-width-expand@s uk-text-center uk-position-z-index-negative" uk-grid>
            <div>
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                    <img class="tm-image-pull" src="../assets/img/sc_dir/4-round.png" width="200" height="200" alt="4">
                    <h4>{{this.$store.getters.GetText.scdir.block_four[this.$store.getters.Lang]}}</h4>
                </div>
            </div>
            <div>
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                    <img class="tm-image-pull" src="../assets/img/sc_dir/5-round.png" width="200" height="200" alt="5">
                    <h4>{{this.$store.getters.GetText.scdir.block_five[this.$store.getters.Lang]}}</h4>
                </div>
            </div>
            <div>
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                    <img class="tm-image-pull" src="../assets/img/sc_dir/6-round.png" width="200" height="200" alt="6">
                    <h4>{{this.$store.getters.GetText.scdir.block_six[this.$store.getters.Lang]}}</h4>
                </div>
            </div>
            <br>
        </div>
        <h3 class="uk-heading">{{this.$store.getters.GetText.scdir.subtitle2[this.$store.getters.Lang]}}</h3>
        <div class="uk-child-width-expand@s uk-text-center uk-position-z-index-negative" uk-grid>
            <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                
                    <img class="tm-image-pull" src="../assets/img/sc_dir/9-round.png" width="200" height="200" alt="6">
                    <h4 v-html="this.$store.getters.GetText.scdir.block_eight[this.$store.getters.Lang]"></h4>                
                </div>
            </div>

            <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">
                
                    <img class="tm-image-pull" src="../assets/img/sc_dir/7-round.png" width="200" height="200" alt="6">
                    <h4 v-html="this.$store.getters.GetText.scdir.block_seven[this.$store.getters.Lang]"></h4>                
                </div>
            </div>

            <div>        
                <div class="uk-panel uk-position-z-index-negative" uk-scrollspy="cls:uk-animation-slide-bottom">                
                    <img class="tm-image-pull" src="../assets/img/sc_dir/8-round.png" width="200" height="200" alt="6">
                <h4 v-html="this.$store.getters.GetText.scdir.block_nine[this.$store.getters.Lang]"></h4>                
                </div>
            </div>

            

            <br>  
        </div>
        <p class="uk-text-large science_direction">{{this.$store.getters.GetText.scdir.footer[this.$store.getters.Lang]}}</p>
        <div v-if="this.$store.getters.GetBlock.registration" class="uk-secction">
            <router-link class="uk-border-rounded uk-button uk-button-primary uk-button-large uk-margin uk-width-expand uk-width-1-3@m" to="/register">{{this.$store.getters.GetText.navbar.reg[this.$store.getters.Lang]}}</router-link>
        </div>
    </div>    
</template>